import TicketItinerary from './TicketItineraryContainer';

export default TicketItinerary;
